import { render, staticRenderFns } from "./BranchNature.vue?vue&type=template&id=1e0774d4&scoped=true"
import script from "./BranchNature.vue?vue&type=script&lang=js"
export * from "./BranchNature.vue?vue&type=script&lang=js"
import style0 from "./BranchNature.vue?vue&type=style&index=0&id=1e0774d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0774d4",
  null
  
)

export default component.exports